import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Currency } from '@domain/model/enums/currency/currency.enum';
import { MAX_NUMBER_ACCOUNTS } from '@modules/business-accounts/utils/constants/user-workflow-constants';
import { IBaseFormBuilder } from '../../builders/base-builder.class';
import { forceValueValidator } from '../validators/force-value.validator';

export class ConfigLegalPersonBuilder implements IBaseFormBuilder {
  private form!: FormGroup;
  currency: Currency | null = Currency.BOTH;

  build({ accountsNumber }: any): void {
    if (accountsNumber && accountsNumber == MAX_NUMBER_ACCOUNTS - 1) {
      this.currency = null;
    }

    this.form = new FormGroup({
      configData: new FormGroup({
        currency: new FormControl(this.currency, [Validators.required]),
      }),
      tAndC: new FormControl(false, [forceValueValidator(true)]),
      personalData: new FormControl(false),
      // charge: new FormControl(false, [forceValueValidator(true)]),
      chargeSunarp: new FormControl(false, [forceValueValidator(true)]),
      acceptNotifyChangeWsp: new FormControl(false, [forceValueValidator(true)]),
    });

    this.addAgencyFields();
    this.addStoreFields();
  }

  getResult(): FormGroup {
    return this.form;
  }

  private addAgencyFields() {
    this.form.addControl(
      'agencyData',
      new FormGroup({
        department: new FormControl('', Validators.required),
        departmentCode: new FormControl('', Validators.required),
        province: new FormControl('', Validators.required),
      })
    );
  }

  private addStoreFields() {
    this.form.addControl(
      'storeData',
      new FormGroup({
        storeCode: new FormControl('898'),
      })
    );
  }
}
